import { Stack } from "@mui/system";
import type { PropsWithChildren } from "react";

function PageLayout({ children }: PropsWithChildren) {
	return <Stack flex={1}>{children}</Stack>;
}

export default PageLayout;
